export default "__VITE_ASSET__BVeWttpg__"